/* eslint-disable */
import { isObject } from 'lodash'
import moment from 'moment'

export const logout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('me')
  localStorage.removeItem('expiresIn')
}

export const isUserAuthenticated = () => !!localStorage.getItem('token')

export const getLanguage = () => localStorage.getItem('lang') || 'en'

export const getToken = () => {
  return localStorage.getItem('token')
}

export const getErrorFields = ({ form, errors, values }) => {
  const fieldErrors = {}

  if (!isObject(errors)) {
    return {}
  }

  Object.keys(errors).map(error => {
    fieldErrors[error] = {
      value: values[error],
      errors: [new Error(errors[error][0])],
    }
    return error
  })
  return form.setFields(fieldErrors)
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function calculateLastWeight({ length, width, height, weight }) {
  const totalVolume = length * width * (height / 139)
  const lastWeight = totalVolume > weight ? totalVolume : weight

  return Math.ceil(lastWeight)
}

export function dateFormatAsLocal(date, format) {
  return moment
    .utc(date)
    .local()
    .format(format || 'YYYY-MM-DD HH:mm:ss')
}

export function dateAsLocal(date) {
  return moment(date)
}

/**
 * @param {Array} array
 */
export const checkContainsConsecutiveNumbers = array => {
  return array.every((num, i) => (array[i + 1] || num + 1) - num === 1)
}

/**
 * @param {string} text
 * @param {string} name
 * @param {string} type
 */
export function downloadFile(text, name, type) {
  const a = document.createElement('a')
  const file = new Blob([text], { type })
  a.href = URL.createObjectURL(file)
  a.download = name
  a.click()
  a.remove()
}

/**
 * @param {Blob} blob
 * @returns {Promise<string>}
 */
export function readFileAsText(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsText(blob)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })
}
